import { render, staticRenderFns } from "./edit-language-text.vue?vue&type=template&id=163dd609&"
import script from "./edit-language-text.vue?vue&type=script&lang=js&"
export * from "./edit-language-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports